<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div id="assets_fluid" class="container-fluid" style="overflow:auto">
        <span style="display: inline;">
          <button
            v-if="asset_cud"
            class="btn btn-info mb-2"
            @click.prevent="addItem"
          >
            <i class="fas fa-plus"></i>
            Add Assets
            <!-- Thêm tài sản -->
          </button>
          &nbsp;
          <button
            v-if="asset_type_rcud"
            class="btn btn-info mb-2"
            @click.prevent="addAssetType"
          >
            <i class="fas fa-plus"></i>
            Add Assets Type
            <!-- Thêm loại tài sản -->
          </button>
          &nbsp;
          <button
            v-if="asset_room_rcud"
            class="btn btn-info mb-2"
            @click.prevent="addRoom"
          >
            <i class="fas fa-plus"></i>
            Add Area
            <!-- Thêm khu vực -->
          </button>
        </span>
        <div class="form-inline" style="width: 100%"></div>
        <!-- style="overflow-x: scroll; width: 100%"      -->
        <b-table
          id="my-table"
          head-variant="dark"
          hover
          responsive
          bordered
          sticky-header="true"
          :no-border-collapse="true"
          striped
          small
          table-variant="light"
          :fields="fields"
          :items="items"
        >
          <template slot="top-row">
            <td style="">
              <b-form-select
                v-model="assetTypeId_filter"
                :options="Assettypes"
                value-field="id"
                text-field="type"
                @change="queryItem"
              >
              </b-form-select>
            </td>
            <td style="">
              <b-form-input
                v-model="assetName_filter"
                @keydown.enter.prevent="queryItem"
              ></b-form-input>
            </td>
            <td style="">
              <multiselect
                v-model="employee_filter"
                placeholder
                track-by="id"
                label="hovaten"
                selectedLabel="Selecting"
                select-label="Enter to select"
                deselectLabel="Enter to delete"
                :searchable="true"
                :options="employees"
                @select="selectEmployee"
                @remove="removeEmployee"
              >
              </multiselect>
            </td>
            <td style="">
              <b-form-select
                v-model="position_filter"
                :options="Positions"
                value-field="id"
                text-field="pickListValue"
                @change="queryItem"
              >
              </b-form-select>
            </td>
            <td style="">
              <b-form-select
                v-model="departmentId_filter"
                :options="Departments"
                value-field="id"
                text-field="madonvi"
                @change="queryItem"
              >
              </b-form-select>
            </td>
            <td style="">
              <b-form-select
                v-model="roomId_filter"
                :options="Rooms"
                value-field="id"
                text-field="name"
                @change="queryItem"
              >
              </b-form-select>
            </td>
            <td style="">
              <b-form-input
                style="background-color: #fff;"
                :disabled="true"
              ></b-form-input>
            </td>
            <td style="">
              <b-form-select
                v-model="status_filter"
                :options="Status"
                value-field="id"
                text-field="pickListValue"
                @change="queryItem"
              >
              </b-form-select>
            </td>
            <td style="">
              <b-form-input
                v-model="recievedDate_filter"
                style="width: 145px;"
                @keydown.enter.prevent="queryItem"
                type="date"
              ></b-form-input>
            </td>
            <td style=""></td>
          </template>
          <template v-slot:cell(position)="data">{{
            data.item.position == null
              ? ""
              : findFirst(vitricongviecs, data.item.position)
          }}</template>
          <template v-slot:cell(status)="data">{{
            data.item.status == null
              ? ""
              : findFirst(tinhtrangtaisans, data.item.status)
          }}</template>
          <template v-slot:cell(roomId)="data">{{
            data.item.roomId == null ? "" : findRoom(rooms, data.item.roomId)
          }}</template>
          <template v-slot:cell(action)="data">
            <div v-if="data.item.id != -1">
              <b-link
                v-if="asset_cud"
                class="text-primary mr-2"
                href="#"
                @click="updateItem(data.item)"
              >
                <i class="fas fa-pencil-alt"></i>
              </b-link>

              <b-link
                v-if="asset_delete"
                class="text-danger"
                href="#"
                @click.prevent="deleteItem(data)"
              >
                <i class="fas fa-trash"></i>
              </b-link>
            </div>
          </template>
          <template v-slot:cell(recievedDate)="data">
            <span> {{ data.item.recievedDate | moment("DD/MM/YYYY") }} </span>
          </template>
          <template v-slot:cell(price)="data">
            <div v-if="data.item.price != 0">
              {{ data.item.price | numeral("0,0") }}
            </div>
            <div v-else></div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "Assets",

  components: {
    Multiselect,
  },

  data() {
    return {
      fields: [
        // @Edit Thanh tam thoi hide
        // {
        //   key: "assetId",
        //   label: "Mã",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {width: "80px", textAlign : "center"},
        // },
        // {
        {
          key: "assetTypeId",
          label: "Assets Type", //"Loại tài sản"
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "170px",
            minWidth: "170px",
            maxWidth: "170px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "assetName",
          label: "Assets Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "auto",
            minWidth: "200px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "employeeFullName",
          label: "Employee Name", //"Nhân viên"
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "200px",
            minWidth: "200px",
            maxWidth: "200px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "position",
          label: "Position", //"Chức danh"
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "200px",
            minWidth: "200px",
            maxWidth: "200px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "departmentId",
          label: "Company", //"Công ty"
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "100px",
            minWidth: "100px",
            maxWidth: "100px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "roomId",
          label: "Area", //"Khu vực"
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "150px",
            minWidth: "150px",
            maxWidth: "150px",
            height: "35px",
            textAlign: "center",
          },
        },
        // {
        //   key: "assetStatus",
        //   label: "Tình trạng",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: {width: "80px", textAlign : "center"},
        // },
        {
          key: "price",
          label: "Price", //"Giá"
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "120px",
            minWidth: "120px",
            maxWidth: "120px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "status",
          label: "Status", //"Hiện trạng"
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "120px",
            minWidth: "120px",
            maxWidth: "120px",
            height: "35px",
            textAlign: "center",
          },
        },
        {
          key: "recievedDate",
          label: "Issued Date", //"Ngày cấp"
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "80px",
            minWidth: "80px",
            maxWidth: "80px",
            height: "35px",
            textAlign: "center",
          },
        },
        // @Edit Thanh tam thoi hide
        // {
        //   key: "notation",
        //   label: "Ghi chú",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {width: "150px", textAlign : "center"},

        // },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "60px",
            minWidth: "60px",
            maxWidth: "60px",
            height: "35px",
            textAlign: "center",
          },
        },
      ],

      items: [],
      assets: [],
      rooms: [],
      query: null,
      tinhtrangtaisans: [],
      item_selected_assetId: "",
      modalShow: false,
      vitricongviecs: [],
      assettypes: [],
      employees: [],
      departments: [],

      assetId_filter: "",
      assetName_filter: "",
      assetTypeId_filter: "",
      employee_filter: [],
      position_filter: "",
      departmentId_filter: "",
      roomId_filter: "",
      // price_filter: "",
      // assetStatus_filter: "",
      status_filter: "",
      recievedDate_filter: "",
      // notation_filter: "",
    };
  },

  computed: {
    //Permission Buuton Them Taisan/Them LoaiTaiSan/Them khu vuc
    asset_cud() {
      return this.$store.getters.hasPermission("asset_cud");
    },
    asset_delete() {
      return this.$store.getters.hasPermission("asset_delete");
    },
    asset_type_rcud() {
      return this.$store.getters.hasPermission("asset_type_rcud");
    },
    asset_room_rcud() {
      return this.$store.getters.hasPermission("asset_room_rcud");
    },

    Assettypes() {
      const null_value = { id: "", type: "" };
      var result = this.assettypes.slice();
      result.unshift(null_value);

      return result;
    },

    Positions() {
      const null_value = { id: "", pickListValue: "" };
      var result = this.vitricongviecs.slice();
      result.unshift(null_value);

      return result;
    },

    Departments() {
      const null_value = { id: "", tendonvi: "", madonvi: "" };
      var result = this.departments.slice();
      result.unshift(null_value);

      return result;
    },

    Rooms() {
      const null_value = { id: "", name: "" };
      var result = this.rooms.slice();
      result.unshift(null_value);

      return result;
    },

    Status() {
      const null_value = { id: "", pickListValue: "" };
      var result = this.tinhtrangtaisans.slice();
      result.unshift(null_value);

      return result;
    },
  },

  beforeRouteEnter(to, from, next) {
    // let query = Object.assign({}, to.query);
    // if (store.state.search != null) query.q = store.state.search.q;
    axios
      .all([
        axios.get("/api/picklist?q=vitricongviec"),
        axios.get("/api/asset", { params: to.params }),
        axios.get("/api/Room"),
        axios.get("/api/picklist?q=tinhtrangtaisan"),
        axios.get("/api/assettype"),
        axios.get("/api/employee/getall"),
        axios.get("/api/department"),
      ])
      .then(
        axios.spread(
          (
            picklist,
            asset,
            room,
            tinhtrangtaisan,
            assettype,
            employee,
            department
          ) => {
            next((vm) =>
              vm.initData(
                picklist.data,
                asset.data,
                room.data,
                tinhtrangtaisan.data,
                assettype.data.items,
                employee.data,
                department.data,
                to.params
              )
            );
          }
        )
      );
  },

  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/asset", { params: to.query })
      .then((response) => {
        this.items = response.data;
        // next();
      })
      .catch((err) => {
        next();
      });
  },

  methods: {
    initData(
      picklists,
      data,
      rooms,
      tinhtrangtaisans,
      assettypes,
      employees,
      departments,
      params /*Search query from Asset Menu*/
    ) {
      this.items = data;
      this.vitricongviecs = picklists.filter(
        (x) => x.pickListType == "vitricongviec"
      );
      this.rooms = rooms;
      this.tinhtrangtaisans = tinhtrangtaisans;
      this.assettypes = assettypes;
      this.employees = employees;
      this.departments = departments;
      this.convertQuery(params);
    },

    initHistoryData(data) {
      this.histories = data;
    },

    addItem() {
      this.$router.push({
        name: "add_asset",
        params: { search: this.createQuery() },
      });
    },

    addAssetType() {
      this.$router.push({
        name: "asset_type",
        params: { search: this.createQuery() },
      });
    },

    addRoom() {
      this.$router.push({
        name: "asset_room",
        params: { search: this.createQuery() },
      });
    },

    updateItem(item) {
      this.$router.push({
        name: "edit_asset",
        params: { slug: item.assetId, search: this.createQuery() },
      });
    },

    deleteItem(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/asset/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successfully", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });

      return temp == null ? "" : temp.pickListValue;
    },

    findRoom(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });

      return temp == null ? "" : temp.name;
    },

    selectEmployee(param) {
      if (param != null) this.employee_filter = param;
      this.queryItem();
    },

    removeEmployee() {
      this.employee_filter = [];
      this.queryItem();
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.createQuery();
      this.$router.push({ query: query });
    },

    createQuery() {
      //#region format employee_filter
      var employeeId_filter = "";
      if (typeof this.employee_filter.id != "undefined")
        employeeId_filter = this.employee_filter.id;
      //#endregion
      return (
        this.assetId_filter +
        "|" +
        this.assetName_filter +
        "|" +
        this.assetTypeId_filter +
        "|" +
        employeeId_filter +
        "|" +
        this.position_filter +
        "|" +
        this.departmentId_filter +
        "|" +
        this.roomId_filter +
        "|" +
        this.status_filter +
        "|" +
        this.recievedDate_filter
      );
    },

    convertQuery(value) {
      // if (this.$store.state.search == null) return;
      //#region Set and Check Search
      // var search_params = ["", "", "", "", "", "", "", "", ""];
      if (!value.q) return;
      var search_params = value.q.split("|");
      if (search_params.length < 9)
        for (let i = search_params.length; i < 9; i++) {
          search_params.unshift("");
        }
      //#endregion
      this.assetId_filter = search_params[0];
      this.assetName_filter = search_params[1];
      this.assetTypeId_filter = search_params[2];
      this.employee_filter = this.employees.filter(
        (item) => item.id == parseInt(search_params[3])
      );
      this.position_filter = search_params[4];
      this.departmentId_filter = search_params[5];
      this.roomId_filter = search_params[6];
      this.status_filter = search_params[7];
      this.recievedDate_filter = search_params[8];
    },
  },
};
</script>
<style>
#assets_fluid .multiselect,
.multiselect__tags {
  min-height: 38px;
}
#assets_fluid .multiselect__content-wrapper {
  width: 300px;
}
/*#region assets table*/
#assets_fluid .b-table-sticky-header {
  height: calc(100vh - 130px);
  max-height: unset;
  min-height: unset;
  margin-bottom: 0rem;
}
#assets_fluid .b-table-top-row td {
  padding: 0.1rem;
  background-color: #5384d1;
  position: -webkit-sticky;
  position: sticky;
  top: 35px;
  z-index: 2;
}
/*#endregion assets table*/
</style>
